export default __webpack_public_path__ + "static/media/background-one-week-plan-min.de41aef7.png";